import http from 'hub-http/clients/apiClient';
const BASE_URL = 'pipelines/v2/pipelines';
let pipelines = null;
export const getPipelines = () => {
  if (pipelines) {
    return Promise.resolve(pipelines);
  }
  return http.get(BASE_URL, {
    query: {
      includeStageMetaPropertyNames: true
    }
  }).then(response => {
    pipelines = response;
    return response;
  });
};